const AddressCard = ({ order }) => {
  return (
    <div className="bg-white rounded-xl p-4 shadow">
      <h2 className="font-semibold mb-2">Default address</h2>
      <p className="text-gray-600">{order.operator.address}</p>
    </div>
  );
};

export default AddressCard;
